import { AavoDialog, AavoDialogProps } from "src/components/common/dialogs/AavoDialog.tsx";
import i18n from "i18next";
import { ErrorText } from "src/components/common/errors/ErrorText.tsx";
import { AavoButton } from "src/components/common/buttons/AavoButton.tsx";
import { AnyError } from "src/errorHandling/anyError.ts";

interface ErrorDialogProps extends Omit<AavoDialogProps, "title" | "actions" | "content" | "open"> {
	error: AnyError | undefined;
}

export const ErrorDialog = ({ error, size = "sm", onClose, ...other }: ErrorDialogProps) => {
	if (error === undefined) return <></>;

	return (
		<AavoDialog
			onClose={onClose}
			size={size}
			title={i18n.t("error")}
			actions={
				<AavoButton
					onClick={(e) => {
						e.preventDefault();
						if (onClose) {
							onClose("escapeKeyDown");
						}
					}}
				>
					{i18n.t("ok")}
				</AavoButton>
			}
			{...other}
		>
			<ErrorText error={error} />
		</AavoDialog>
	);
};
